import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {
  TrendDataTableAttrs,
  TrendDataTableEventListeners,
  TrendDataTableProps,
  TrendDataTableRow,
  TrendDataTableSegment,
  TrendDataTableState,
  ValueFormatterFunc,
} from 'common/widgets/trend-data-table/types';
import {LineDataTableFields} from 'common/widgets/trend-data-table/utils';
import {SortBy, SortOrder} from 'common/charts/visualization/bar-viz/types';

import {template} from './template';

export class TrendDataTable extends Component<TrendDataTableState, TrendDataTableAttrs> implements TrendDataTableProps {
  private _segments: TrendDataTableSegment[] = [];
  private _rows: TrendDataTableRow[] = [];
  private _valueFormatter: ValueFormatterFunc;

  static get attrsSchema(): AttrsSchema<TrendDataTableAttrs> {
    return {
      'default-sorting': {
        type: `json`,
        tsType: `TableSortConfig`,
        default: {
          sortBy: SortBy.Value,
          sortOrder: SortOrder.Descending,
          valueField: LineDataTableFields.Average,
          colSortAttrs: [],
        },
      },
      'selection-limit': {
        type: `number`,
        description: `maximum number of item selections to allow`,
        default: 10,
      },
      'track-name': `string`,
      'trend-unit': `string`,
    };
  }

  get config() {
    return {template};
  }

  set segments(segments: TrendDataTableSegment[]) {
    this._segments = segments;
    this.update();
  }

  get segments() {
    return this._segments;
  }

  set rows(rows: TrendDataTableRow[]) {
    this._rows = rows;
    this.update();
  }

  get rows() {
    return this._rows;
  }

  set valueFormatter(valueFormatter: ValueFormatterFunc) {
    this._valueFormatter = valueFormatter;
    this.update();
  }

  get valueFormatter() {
    return this._valueFormatter;
  }
}

export const TrendDataTableEl = defineAndMakeJsxFactory<{
  props: TrendDataTableProps;
  attrs: TrendDataTableAttrs;
  on: Partial<TrendDataTableEventListeners>;
}>(`mp-trend-data-table`, TrendDataTable);
